import React from "react";
import {
  MdArrowOutward,
  MdCheckCircle,
  MdAutoAwesome,
  MdLightbulb,
  MdHandshake,
  MdVerified,
  MdTrendingUp,
  MdPalette,
  MdPhotoCamera,
  MdWeb,
} from "react-icons/md";
import imageAbout from "../../assest/aboutImg.gif";
import "./homeAbout.scss";

const services = [
  {
    icon: <MdWeb />,
    number: "01",
    title: "Web Development",
    tagline: "Fast. Responsive. Built to convert.",
    description:
      "From landing pages to full-stack web apps, I craft digital experiences that are pixel-perfect on every device. Clean code meets compelling design to drive real results.",
    features: ["React & Next.js", "Mobile-First Design", "SEO Optimized", "Performance Tuned"],
    detail: "Websites · Front-end · UX Engineering",
    color: "#e3ba72",
  },
  {
    icon: <MdPhotoCamera />,
    number: "02",
    title: "Photography",
    tagline: "Moments worth remembering, forever.",
    description:
      "Every frame tells a story. I photograph weddings, portraits, events, and brands with a documentary eye — natural, emotive, and timeless imagery that truly resonates.",
    features: ["Weddings & Events", "Brand Photography", "Portrait Sessions", "High-Res Delivery"],
    detail: "Weddings · Portraits · Events · Brand",
    color: "#b8a9d9",
  },
  {
    icon: <MdPalette />,
    number: "03",
    title: "Design & Visual Content",
    tagline: "Visuals that speak before words do.",
    description:
      "Strategic branding, polished UI/UX, and social-ready content that makes your business unforgettable. From logo to full brand identity, I craft visuals with purpose.",
    features: ["Brand Identity", "UI / UX Design", "Social Media Content", "Print & Digital"],
    detail: "Branding · UI/UX · Content Design",
    color: "#72b8e3",
  },
];


const values = [
  {
    icon: <MdLightbulb />,
    title: "Creative Thinking",
    desc: "Every project starts with understanding your vision, then crafting a strategy that makes it extraordinary.",
  },
  {
    icon: <MdHandshake />,
    title: "True Partnership",
    desc: "I work alongside you — not just for you. Your feedback shapes every iteration until it's exactly right.",
  },
  {
    icon: <MdVerified />,
    title: "Quality Obsessed",
    desc: "Zero shortcuts. Every pixel, line of code, and photograph is held to the highest standard of craft.",
  },
  {
    icon: <MdTrendingUp />,
    title: "Results Driven",
    desc: "Beautiful isn't enough. Everything I build is designed to perform, convert, and grow with your business.",
  },
];

const promises = [
  "Thoughtful, tailored work for every client",
  "Clear communication from day one",
  "Care and precision in every detail",
  "On-time delivery, every time",
];

const processSteps = [
  { num: "01", step: "Discover", desc: "Understanding your goals, audience, and vision." },
  { num: "02", step: "Design", desc: "Crafting the look, feel, and user experience." },
  { num: "03", step: "Develop", desc: "Bringing ideas to life with precision and care." },
  { num: "04", step: "Deliver", desc: "Launching polished work, on time and on brand." },
];



/* ─── Component ─────────────────────────────────────────────────────────── */
function HomeAbout() {
  return (
    <section className="ha-section" aria-labelledby="ha-title">
      {/* ambient blobs */}
      <div className="ha-blob ha-blob--gold" aria-hidden="true" />
      <div className="ha-blob ha-blob--blue" aria-hidden="true" />
      <div className="ha-bg-grid" aria-hidden="true" />

      <div className="ha-inner">

        {/* ── Intro ── */}
        <div className="ha-intro" data-aos="fade-up">
          <span className="ha-eyebrow">
            <MdAutoAwesome aria-hidden="true" />
            A creative partner for your next step
          </span>
          <h1 id="ha-title">
            Everything you needs.
            <br />
            <span className="ha-gradient-text">Built by one creator.</span>
          </h1>
          <p className="ha-lead">
            I combine web development, photography, and visual design under one roof so your
            business shows up with clarity, confidence, and consistency everywhere that matters.
          </p>

          <div className="ha-about-image-wrap" aria-label="Creative work illustration">
            <img src={imageAbout} alt="Creative work illustration" className="ha-about-image" />
          </div>
        </div>




        {/* ── Values ── */}
        <div className="ha-values-wrap" data-aos="fade-up">
          <div className="ha-values">
            {values.map((v, i) => (
              <div
                className="ha-value-card"
                key={v.title}
                data-aos="fade-up"
                data-aos-delay={i * 80}
              >
                <span className="ha-value-card__icon" aria-hidden="true">
                  {v.icon}
                </span>
                <h4>{v.title}</h4>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Promise / CTA Banner ── */}
        <div className="ha-promise" data-aos="fade-up">
          <div className="ha-promise__left">
            <span className="ha-section-tag">What you can expect</span>
            <h2>
              Work shaped around <span>your goals</span>
            </h2>
            <p>
              I believe the details matter. from the first conversation to the final deliverable.
              Every project is built with care, shaped by your feedback, and crafted to last.
            </p>
            <ul className="ha-promise__list">
              {promises.map((p) => (
                <li key={p}>
                  <MdCheckCircle aria-hidden="true" />
                  {p}
                </li>
              ))}
            </ul>
            <a className="ha-cta" href="#contact">
              Let's talk about your project <MdArrowOutward aria-hidden="true" />
            </a>
          </div>
          <div className="ha-promise__right" aria-hidden="true">
            <div className="ha-process">
              {processSteps.map((s) => (
                <div className="ha-process__step" key={s.step}>
                  <div className="ha-process__dot">
                    <span>{s.num}</span>
                  </div>
                  <div className="ha-process__content">
                    <strong>{s.step}</strong>
                    <span>{s.desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default HomeAbout;
